import { userConstants } from './../constants/user.constants';

const initialState = {};

export function Disbursedstatuschange(state = initialState, action) {
  switch (action.type) {
    case userConstants.DISBURSERDSTATUSCHANGE_REQUEST:
      return {
        user: action.user,
        isLoading : true

      };
    case userConstants.DISBURSERDSTATUSCHANGE_SUCCESS:
      const {res} = action
        
      return {
        res,
        isLoading : false
      };
    case userConstants.DISBURSERDSTATUSCHANGE_FAILURE:
      return {
        isLoading : false
      };
    default:
      return state
  }
}